import { plural } from './plural'

const who = (by: unknown) => (by ? ` (${by})` : '')

export const ru = {
  'lang.label': 'Язык интерфейса',
  'common.home': 'На главную',
  'common.guest': 'Гость',

  'unit.mbps': '{v} МБ/с',
  'unit.kbps': '{v} КБ/с',
  'unit.gb': '{v} ГБ',
  'unit.mb': '{v} МБ',

  'home.title': 'Кино на всех, с одной кнопки паузы',
  'home.lead':
    'Фильм качается из торрента и сразу играет у всех в комнате. Если у кого-то не успело подгрузиться, пауза ставится у всех, а на экране видно, кого ждём. Озвучку и субтитры каждый выбирает для себя.',
  'home.newRoom': 'Новая комната',
  'home.name': 'Название',
  'home.namePlaceholder': 'Пятничное кино',
  'home.defaultName': 'Комната',
  'home.token': 'Токен создания',
  'home.rememberToken': 'Запомнить токен на этом устройстве',
  'home.create': 'Создать комнату',
  'home.friendsHint': 'Друзьям токен не нужен: они заходят по ссылке на комнату.',
  'home.errToken': 'Токен не подошёл.',
  'home.errRate': 'Слишком много попыток. Попробуйте через 10 минут.',
  'home.errServer': 'Не удалось создать комнату. Сервер недоступен.',

  'room.notFound': 'Такой комнаты нет. Проверьте ссылку.',
  'room.serverDown': 'Сервер недоступен.',
  'room.opening': 'Открываем комнату',
  'room.connecting': 'Подключаемся',
  'room.kicked': 'Владелец удалил вас из комнаты.',
  'room.deleted': 'Комната удалена.',
  'room.gone': 'Такой комнаты больше нет.',
  'room.banned': 'Вас удалили из этой комнаты.',
  'room.homeAria': 'chillio, на главную',
  'room.reconnecting': 'Переподключаемся…',
  'room.rename': 'Сменить имя',
  'room.renamePrompt': 'Ваше имя в комнате',
  'room.copyLink': 'Ссылка на комнату',
  'room.invite': 'Позвать',
  'room.browser': 'В браузере',
  'room.browserAria': 'Комната в браузере',
  'room.browserLink': 'Ссылка для браузера',
  'room.browserLinkHint': 'Кто откроет её, войдёт в эту комнату с сайта — без Discord.',
  'room.copy': 'Копировать',
  'room.openInBrowser': 'Открыть у себя в браузере',
  'room.openInBrowserHint': 'Полный экран без панелей Discord. Вы войдёте как {name}.',
  'room.handoffFailed': 'Не получилось, попробуйте ещё раз',
  'presence.paused': 'На паузе',
  'presence.watching': 'Смотрят вместе',
  'discord.connecting': 'Подключаемся к Discord…',
  'discord.problem.not_configured': 'Discord Activity не настроена на сервере.',
  'discord.problem.denied': 'Без входа через Discord смотреть вместе не получится.',
  'discord.problem.not_in_activity': 'Discord не подтвердил, что вы в этой активности. Перезапустите её из голосового канала.',
  'discord.problem.server': 'Сервер chillio не отвечает. Попробуйте ещё раз чуть позже.',
  'discord.problem.invalid_token': 'Токен не подошёл.',
  'discord.problem.too_many': 'Слишком много попыток. Попробуйте через 10 минут.',
  'discord.activate.title': 'Подключите chillio здесь',
  'discord.activate.text': 'Здесь chillio запускают впервые. Введите токен создания комнат — его знает тот, кто поднял chillio. Это нужно один раз: дальше комнаты здесь создаются без токена.',
  'discord.activate.token': 'Токен создания комнат',
  'discord.activate.submit': 'Подключить',
  'discord.retry': 'Попробовать снова',
  'discord.fullscreenTip': 'Discord не даёт активностям настоящий полный экран. Без его панелей можно смотреть в браузере: «В браузере» → «Открыть у себя в браузере».',
  'player.codecFallback': 'Это устройство не декодирует видео в исходном качестве (например, в Discord выключено аппаратное ускорение). Включили совместимый режим 720p.',
  'player.quality': 'Качество',
  'player.qualityAria': 'Качество: {name}',
  'player.qualityAuto': 'Авто',
  'player.qualityAutoHint': 'оригинал, при слабой связи — 720p',
  'player.qualityAutoNow': 'сейчас 720p: связь не тянет оригинал',
  'player.qualityOriginal': 'Оригинал',
  'player.qualityOriginalHint': '{res} без перекодирования',
  'player.qualityUnavailable': 'это устройство его не декодирует — будет 720p',
  'player.qualityCompressed': 'Сжатое',
  'player.qualityCompressedHint': '720p, меньше трафика — сервер перекодирует',
  'player.autoCompressed': 'Связь не тянет оригинал — переключились на 720p. Вернуть можно в меню качества.',
  'room.copyLinkAria': 'Скопировать ссылку на комнату',
  'room.copied': 'Скопировано',
  'dialog.ok': 'ОК',
  'dialog.cancel': 'Отмена',
  'dialog.save': 'Сохранить',
  'dialog.done': 'Готово',
  'room.tabChat': 'Чат',
  'room.tabEpisodes': 'Серии',
  'room.tabMovie': 'Фильм',

  'join.title': 'Как вас подписать?',
  'join.name': 'Имя в комнате',
  'join.submit': 'Войти в комнату',
  'join.remember': 'Имя запомнится на этом устройстве.',
  'join.linkExpired': 'Ссылка для входа из Discord устарела. Откройте её из Discord заново или войдите с именем.',

  'empty.analyzing': 'Готовим видео',
  'empty.analyzingHint': 'Скачиваем заголовок файла и читаем дорожки. Обычно это несколько секунд.',
  'empty.failed': 'Этот файл не открылся',
  'empty.metadata': 'Получаем список файлов торрента',
  'empty.metadataHint': 'Ищем пиров и загружаем метаданные раздачи.',
  'empty.sourceFailed': 'Торрент не добавился',
  'empty.choose': 'Выберите, что смотреть',
  'empty.ownerChoosing': 'Владелец выбирает, что смотреть',
  'empty.addTorrent': 'Добавьте торрент, чтобы начать',
  'empty.noTorrent': 'Владелец ещё не добавил фильм',
  'empty.addHint': 'Вставьте magnet-ссылку или загрузите .torrent на вкладке «{tab}».',
  'empty.chooseTitle': 'Выберите, что смотрим',
  'empty.chooseTitleHint': 'На вкладке «{tab}» найдите фильм или сериал, потом выберите для него раздачу.',
  'empty.noTitle': 'Владелец ещё не выбрал, что смотрим',
  'empty.chooseRelease': 'Выберите раздачу',
  'empty.chooseReleaseHint': 'На вкладке «{tab}»: из каталога или свою — magnet-ссылку или .torrent.',

  'wait.starting': 'Запускаем',
  'wait.loading': 'Загружаем видео',
  'wait.noPeers': 'Ищем источники: пока ни одного пира',
  'wait.torrent': (v) =>
    `Торрент: ${v.rate}, ${v.n} ${plural('ru', Number(v.n), { one: 'пир', few: 'пира', many: 'пиров', other: 'пира' })}`,
  'wait.members': 'Ждём, пока подгрузится',
  'wait.continue': 'Продолжить без ожидания',
  'wait.encoding': 'Сервер не успевает сжимать видео',
  'wait.encodingHint': 'Сжатие в 720p идёт медленнее просмотра. Без ожидания пойдёт «Оригинал» в меню качества или раздача в 1080p.',
  'wait.skipOnce': 'Не дожидаться в этот раз',
  'wait.skipOnceFor': 'Не дожидаться {name} в этот раз',
  'wait.never': 'Никогда не ждать',
  'wait.neverFor': 'Никогда не ждать {name}',
  'wait.offline': 'Нет связи с сервером',
  'wait.offlineHint': 'Переподключаемся. Видео продолжится вместе со всеми.',

  'player.play': 'Смотреть',
  'player.askPlay': 'Попросить продолжить',
  'player.pause': 'Пауза',
  'player.askTitle': 'Отправить запрос владельцу',
  'player.unmute': 'Включить звук',
  'player.mute': 'Выключить звук',
  'player.volume': 'Громкость',
  'player.seek': 'Перемотка',
  'player.askSeek': 'Попросить перемотку',
  'player.reaction': 'Реакция',
  'player.reactions': 'Реакции',
  'player.reactionOne': 'Реакция {emoji}',
  'player.audio': 'Озвучка',
  'player.audioAria': 'Озвучка: {name}',
  'player.noAudio': 'Без звука',
  'player.subs': 'Субтитры',
  'player.subsAria': 'Субтитры: {name}',
  'player.subsOff': 'Без субтитров',
  'player.fullscreen': 'Во весь экран',
  'player.exitFullscreen': 'Выйти из полноэкранного режима',
  'player.theater': 'Кинорежим: только фильм',
  'player.exitTheater': 'Выйти из кинорежима',
  'player.fill': 'Заполнить экран (края кадра обрежутся)',
  'player.channels': '{n} кан.',
  'player.externalFile': 'отдельный файл',
  'player.subsImage': 'картинками, пока не поддерживаются',
  'player.forced': 'только надписи',
  'player.track': 'Дорожка {n}',
  'player.subsSettings': 'Вид субтитров…',
  'player.pip': 'Картинка в картинке',
  'player.remaining': 'Показать оставшееся время',
  'player.elapsed': 'Показать прошедшее время',
  'player.withKey': '{label} ({key})',
  'osd.volume': 'Громкость {n}%',
  'osd.muted': 'Звук выключен',
  'osd.fill': 'Кадр на весь экран',
  'osd.fit': 'Кадр целиком',
  'osd.audio': 'Озвучка: {name}',
  'osd.subs': 'Субтитры: {name}',
  'osd.subsOff': 'Субтитры выключены',
  'osd.noSubs': 'В этом видео нет субтитров',
  'osd.subsSize': 'Размер субтитров {n}%',
  'osd.subsDelay': 'Задержка субтитров {n} с',
  'osd.seek': '{delta} с · {time}',
  'subs.sample': 'Так будут выглядеть субтитры',
  'subs.assMode': 'Стиль ASS',
  'subs.assOriginal': 'Оригинальный',
  'subs.assPlain': 'Простой текст',
  'subs.assOriginalHint': 'Шрифты и оформление как задумал автор. Чтобы менять размер, шрифт и цвет, включите «Простой текст».',
  'subs.size': 'Размер',
  'subs.font': 'Шрифт',
  'subs.font.sans': 'Обычный',
  'subs.font.serif': 'С засечками',
  'subs.font.mono': 'Моноширинный',
  'subs.font.rounded': 'Округлый',
  'subs.fontSample': 'Аа',
  'subs.color': 'Цвет',
  'subs.edge': 'Контур',
  'subs.edge.none': 'Нет',
  'subs.edge.outline': 'Обводка',
  'subs.edge.shadow': 'Тень',
  'subs.background': 'Подложка',
  'subs.delay': 'Задержка',
  'subs.secondsUnit': 'с',
  'subs.position': 'Положение',
  'subs.positionHint': 'Перетащите субтитры прямо на видео мышью или пальцем.',
  'subs.positionReset': 'Вернуть вниз по центру',
  'subs.drag': 'Перетащите меня',
  'subs.back': 'К дорожкам',
  'subs.delayHint': 'Опаздывают — уменьшите, спешат — увеличьте. Можно вписать число, например -1.5. Клавиши G и H.',
  'subs.seconds': '{n} с',
  'subs.earlier': 'Раньше на 0,1 с',
  'subs.later': 'Позже на 0,1 с',
  'subs.zero': 'Сбросить',
  'subs.reset': 'Вернуть настройки по умолчанию',
  'keys.title': 'Горячие клавиши',
  'keys.close': 'Закрыть',
  'keys.playback': 'Воспроизведение',
  'keys.sound': 'Звук',
  'keys.subtitles': 'Субтитры',
  'keys.view': 'Вид',
  'keys.play': 'Пауза и продолжение',
  'keys.seek5': 'Назад и вперёд на 5 секунд',
  'keys.seek10': 'Назад и вперёд на 10 секунд',
  'keys.percent': 'Перейти к 0–90% фильма',
  'keys.ends': 'В начало и в конец',
  'keys.volume': 'Громкость',
  'keys.mute': 'Выключить и включить звук',
  'keys.audio': 'Следующая озвучка',
  'keys.subsToggle': 'Включить и выключить субтитры',
  'keys.subsNext': 'Следующие субтитры',
  'keys.subsSize': 'Размер субтитров',
  'keys.subsDelay': 'Субтитры раньше и позже',
  'keys.fullscreen': 'Во весь экран (или двойной клик)',
  'keys.pip': 'Картинка в картинке',
  'keys.fill': 'Заполнить экран или показать кадр целиком',
  'keys.help': 'Эта подсказка',

  'seats.label': 'Зрители',
  'seat.away': 'не в комнате',
  'seat.waited': 'ждём, {pct}%',
  'seat.catchingUp': 'догоняет',
  'seat.loading': 'загружается',
  'seat.watching': 'смотрит',
  'seat.owner': 'Владелец',
  'seat.controller': 'Управляет воспроизведением',
  'seat.youStatus': 'вы · {status}',
  'seat.allow': 'Разрешить управлять',
  'seat.allowHint': 'пауза и перемотка без запросов',
  'seat.revoke': 'Забрать управление',
  'seat.makeOwner': 'Сделать владельцем',
  'seat.makeOwnerConfirm': 'Передать комнату участнику {nick}? Вы останетесь управляющим.',
  'seat.kick': 'Удалить из комнаты',
  'seat.noWait': 'Никогда не ждать',
  'seat.noWaitHint': 'комната не будет останавливаться из-за загрузки',
  'seat.noWaitBadge': 'Его не ждём',
  'seat.kickConfirm': 'Удалить {nick} из комнаты?',

  'chat.empty': 'Здесь будут сообщения и события комнаты.',
  'chat.placeholder': 'Сообщение',
  'chat.send': 'Отправить',

  'source.torrent': 'Раздача',
  'source.metadata': 'Получаем список файлов…',
  'source.change': 'Сменить',
  'source.noTorrent': 'Владелец ещё не добавил торрент.',
  'source.nothingYet': 'Владелец ещё не выбрал, что смотрим.',
  'source.stats': (v) =>
    `${v.n} ${plural('ru', Number(v.n), { one: 'пир', few: 'пира', many: 'пиров', other: 'пира' })}, загрузка ${v.rate}`,
  'source.noVideos': 'В раздаче нет видеофайлов.',
  'source.autoplay': 'Включать следующую серию',
  'source.magnet': 'Magnet-ссылка',
  'source.add': 'Добавить',
  'source.upload': 'Загрузить .torrent',
  'source.cancel': 'Отмена',
  'source.sectionTitle': 'Что смотрим',
  'source.sectionRelease': 'Раздача',
  'source.sectionFile': 'Файл',
  'source.sectionEpisodes': 'Серии · {n}',
  'source.episode': 'Серия {n}',
  'source.findReleases': 'Найти раздачу в каталоге',
  'source.orOwn': 'или своя раздача',
  'source.otherTitle': 'Эта раздача выбрана для другого фильма.',
  'source.findForTitle': 'Найти раздачу для «{title}»',


  'request.pause': 'просит поставить паузу',
  'request.play': 'просит продолжить',
  'request.seek': 'просит перемотать на {time}',
  'request.accept': 'Принять',
  'request.decline': 'Отклонить',

  'ev.play': (v) => `Воспроизведение${who(v.by)}`,
  'ev.pause': (v) => `Пауза на ${v.time}${who(v.by)}`,
  'ev.seek': (v) => `Перемотка на ${v.time}${who(v.by)}`,
  'ev.buffering': (v) => (v.by ? `Подгружается у ${v.by}, ждём` : 'Подгрузка, ждём'),
  'ev.loading': 'Ждём загрузку из торрента',
  'ev.skip': (v) => `Продолжаем без ожидания${who(v.by)}`,
  'ev.ended': 'Серия закончилась',
  'ev.selecting': '{by} выбирает, что смотреть',

  'notice.askedPause': 'Попросили поставить паузу',
  'notice.askedPlay': 'Попросили продолжить',
  'notice.askedSeek': 'Попросили перемотать на {time}',
  'notice.requestExpired': 'Запрос остался без ответа',
  'notice.requestAccepted': (v) => `Запрос принят${who(v.by)}`,
  'notice.requestDeclined': (v) => `Запрос отклонён${who(v.by)}`,
  'notice.subtitleAdded': 'Добавлены субтитры «{name}» ({by})',
  'notice.subtitleFollowed': 'Субтитры подобраны для этой серии: «{name}»',
  'catalog.select': 'Выбрать',
  'catalog.selectHint': 'Без раздачи: её можно выбрать позже или загрузить свою',
  'catalog.createRoomBare': 'Создать комнату без раздачи',
  'catalog.createRoomBareHint': 'Раздачу можно выбрать в комнате или загрузить свою',
  'title.clear': 'Убрать',
  'title.choose': 'Выбрать фильм или сериал',
  'title.hint': 'По выбранному фильму ищутся субтитры — и для своей раздачи тоже.',
  'subsearch.open': 'Найти субтитры…',
  'subsearch.title': 'Субтитры с OpenSubtitles',
  'subsearch.languages': 'Языки',
  'subsearch.season': 'Сезон',
  'subsearch.episode': 'Серия',
  'subsearch.search': 'Искать',
  'subsearch.searching': 'Ищем…',
  'subsearch.empty': 'Ничего не нашлось. Попробуйте другие языки или серию.',
  'subsearch.add': 'Добавить',
  'subsearch.adding': 'Скачиваем…',
  'subsearch.turnOn': 'Включить',
  'subsearch.hashMatch': 'Для этого файла',
  'subsearch.hashMatchHint': 'Сделаны под этот самый файл — должны идти точно в такт',
  'subsearch.hi': 'для слабослышащих',
  'subsearch.machine': 'машинный перевод',
  'subsearch.downloads': 'скачиваний: {n}',
  'subsearch.byHashOnly': 'Фильм не выбран, поэтому ищем только по самому файлу. Выберите фильм или сериал во вкладке рядом с чатом, чтобы найти больше.',
  'subsearch.noTarget': 'Сначала выберите фильм или сериал во вкладке рядом с чатом: по нему ищутся субтитры.',
  'subsearch.quota': 'Лимит скачиваний OpenSubtitles на сегодня исчерпан. Попробуйте завтра.',
  'subsearch.expired': 'Результаты устарели — повторите поиск.',
  'subsearch.error': 'Не получилось: {message}',
  'subsearch.close': 'Закрыть',
  'subsearch.note': 'Скачивания анонимные, около 20 в день на весь сервер. Субтитры сохраняются для этого файла у всех.',
  'notice.roleOwner': 'Теперь вы владелец комнаты',
  'notice.roleController': 'Теперь вы управляете воспроизведением',
  'notice.roleViewer': 'Управление воспроизведением снято',
  'notice.forbidden': 'Это может сделать только владелец или управляющий',
  'notice.rateLimited': 'Слишком часто, подождите немного',
  'notice.error': 'Ошибка: {message}',

  'catalog.title': 'Каталог',
  'catalog.find': 'Найти фильм или сериал',
  'catalog.open': 'Найти в каталоге',
  'catalog.homeLink': 'Найти фильм в каталоге',
  'catalog.searchPlaceholder': 'Название фильма или сериала',
  'catalog.searchLabel': 'Поиск по каталогу',
  'catalog.hint': 'Начните вводить название: подскажем фильмы и сериалы, а после выбора найдём раздачи.',
  'catalog.movie': 'Фильм',
  'catalog.tv': 'Сериал',
  'catalog.searching': 'Ищем…',
  'catalog.noResults': 'Ничего не нашлось',
  'catalog.loading': 'Загружаем описание…',
  'catalog.back': 'Назад',
  'catalog.close': 'Закрыть',
  'catalog.minutes': '{n} мин',
  'catalog.seasonsCount': (v) => `${v.n} ${plural('ru', Number(v.n), { one: 'сезон', few: 'сезона', many: 'сезонов', other: 'сезона' })}`,
  'catalog.season': 'Сезон {n}',
  'catalog.seasonsRange': 'Сезоны {a}–{b}',
  'catalog.allSeasons': 'Все сезоны',
  'catalog.seasonPick': 'Сезон',
  'catalog.releases': 'Раздачи',
  'catalog.releasesLoading': 'Ищем раздачи на трекерах…',
  'catalog.noReleases': 'Раздач не нашлось. Попробуйте другой сезон или добавьте торрент вручную.',
  'catalog.tracks.button': 'Дорожки',
  'hdr.aria': '{name}: как показывается видео',
  'hdr.on': 'Экран показывает это видео в HDR: полная яркость и цвет.',
  'hdr.screenOff': 'Видео в HDR, но экран сейчас работает в SDR, поэтому браузер приглушает картинку. Если экран поддерживает HDR, включите его в системе — видео станет ярче сразу, без перезагрузки.',
  'hdr.transcoded': 'Этот браузер не умеет декодировать видео, поэтому вы смотрите его SDR-копию в 720p. HDR покажут Chrome, Edge или Safari с поддержкой HEVC 10 бит.',
  'hdr.dvOnly': 'Dolby Vision профиля 5 без HDR10-основы: браузеры показывают его с искажёнными цветами (фиолетовые и зелёные оттенки). Лучше выбрать другую раздачу.',
  'hdr.howWindows': 'Windows: нажмите Win + Alt + B или включите «Использовать HDR» в Параметры → Система → Дисплей.',
  'hdr.howMac': 'Mac включает HDR сам на экранах с его поддержкой (MacBook Pro с XDR, Pro Display XDR и другие). На этом экране его нет.',
  'hdr.howOther': 'Включите HDR в настройках экрана системы, если он его поддерживает.',
  'hdr.hintTitle': 'Этот фильм в HDR, а HDR на экране выключен.',
  'hdr.dismiss': 'Больше не показывать',
  'catalog.tracks.more': 'Подробнее',
  'catalog.tracks.less': 'Свернуть',
  'catalog.tracks.loading': 'Загружаем дорожки',
  'catalog.tracks.unknown': 'Дорожки неизвестны',
  'catalog.tracks.fileShort': 'из файла',
  'catalog.tracks.descriptionShort': 'по описанию',
  'catalog.tracks.fileHint': 'Проверено по самому файлу',
  'catalog.tracks.descriptionHint': 'Со слов автора раздачи, файл ещё проверяется',
  'catalog.tracks.fromFile': 'Из файла',
  'catalog.tracks.episode': 'серия 1 из {n}',
  'catalog.tracks.fromDescription': 'По описанию раздачи',
  'catalog.tracks.probing': 'Проверяем сам файл у раздающих…',
  'catalog.tracks.probeFailed': 'Файл проверить не удалось: {error}',
  'catalog.tracks.timeout': 'раздающие не отдали начало файла за минуту',
  'catalog.tracks.notInDescription': 'В описании раздачи дорожки не указаны.',
  'catalog.tracks.translation': 'Перевод',
  'catalog.tracks.audio': 'Звук',
  'catalog.tracks.subtitles': 'Субтитры',
  'catalog.tracks.none': 'нет',
  'catalog.tracks.external': 'отдельный файл',
  'catalog.tracks.forced': 'форсированные',
  'catalog.tracks.unsupported': 'не поддерживаются плеером',
  'catalog.sourceError.blocked': '{provider} не отвечает этому серверу: сайт показывает проверку Cloudflare. Нужен другой сетевой адрес или прокси (HTTPS_PROXY).',
  'catalog.sourceError.login': '{provider}: не удалось войти, проверьте логин и пароль.',
  'catalog.sourceError.captcha': '{provider} просит капчу при входе: войдите в браузере и укажите cookie сессии в настройках.',
  'catalog.peersTitle': 'Сиды: {s}, личи: {l}',
  'catalog.openTopic': 'Открыть раздачу на трекере',
  'catalog.disc': 'Образ диска',
  'catalog.episodes': 'Серии {e}',
  'catalog.watch': 'Смотреть',
  'catalog.createRoom': 'Создать комнату',
  'catalog.adding': 'Скачиваем .torrent…',
  'catalog.tokenNeeded': 'Каталог доступен с токеном создания комнат.',
  'catalog.continue': 'Продолжить',
  'catalog.unavailable': 'Каталог не настроен на сервере.',
} satisfies Record<string, string | ((v: Record<string, unknown>) => string)>
